import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

function DeleteModel(props) {
  const { showModal, onClose, onDelete, title, message, confirmLabel, size, dialogClassName } = props;
  const [show, setShow] = useState(showModal);

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size={size} dialogClassName={dialogClassName}>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Confirm delete'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <WarningAmberRoundedIcon style={{ color: '#d9534f', fontSize: 34, flexShrink: 0 }} />
          <div>
            <p style={{ margin: 0, fontWeight: 500 }}>
              {message || 'Are you sure you want to delete this item?'}
            </p>
            <p style={{ margin: '6px 0 0', fontSize: 13, color: '#888' }}>
              This action cannot be undone.
            </p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          {confirmLabel || 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModel;
